import React, {Component} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';

class PublicRoute extends Component {
	render() {
		const {component: Component, session, ...rest} = this.props;
		return (
			<Route
				{...rest}
				render={
					props => (
						(session && session.token)
						? <Redirect to={{
								pathname: '/',
								state: { from: props.location }
							}}/>
						: <Component {...props}/>
					)
				}
			/>
		)
	}
}

const mapStateToProps = state => ({
	session: state.session
});

export default connect(mapStateToProps)(PublicRoute);
